import FormattedMessage from 'I18n/components/FormattedMessage';
import { areWebhookTriggersAllowedForObjectType } from 'automation-ui-enrollment/hooks/useHasWebhookTriggersAccess';
import WorkflowTypeSelect from 'automation-ui-enrollment/components/workflowType/WorkflowTypeSelect';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WebhookObjectTypeSelect({
  objectTypeId,
  setObjectTypeId
}) {
  return /*#__PURE__*/_jsx(WorkflowTypeSelect, {
    objectTypeId: objectTypeId,
    objectTypeFilter: typeId => areWebhookTriggersAllowedForObjectType(typeId) && typeId !== UNKNOWN_ID,
    onChange: setObjectTypeId,
    formControlProps: {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.associatingObject.objectSelectLabel"
      })
    }
  });
}